import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-raw-table',
  templateUrl: './raw-table.component.html',
  styleUrls: ['./raw-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RawTableComponent implements OnInit {

  @Input() arrMulCdcInfo: Array<any>;

  constructor() { }

  ngOnInit() {
  }

}
